import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import Cookies from 'js-cookie'
import Backbtn from './elements/Backbtn'
import { Footer, Nav, Loader, Analytics } from './elements'

import { brandFetch, documentFetchBrand } from '../redux/actions'

class Downloadbrand extends Component {

    constructor() {
        super()
        this.state = {
            isLogin: false,
            user: "",
            brands: [],
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
        this.props.brandFetch()
        this.props.documentFetchBrand()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.brands || nextProps.documents) {
            if (nextProps.documents) {
                const brands = []
                nextProps.brands.forEach(item => {
                    const temp = nextProps.documents.find(item2 => item2.brand_id === item.id)
                    if (temp) brands.push(item)
                });
                this.setState({ brands })
            }
        }
    }

    showBrands() {
        if(this.state.brands.length > 0) {
            return this.state.brands.map((item, index) => {
                return (
                    <div className="each-brand" key={++index}>
                        <Link to={{ pathname: "/downloaddetail", search: `brand_id=${item.id}`}}>
                            <img src={item.img} alt={item.title}/>
                        </Link>
                    </div>
                )
            })
        } else {
            return <Loader />
        }
    }

    render() { 
        if(!this.state.isLogin) return <div></div>
        return ( 
            <div className="page-downloadbrand">
                <Analytics />
                <div className="downloadbrand-header">
                    <Backbtn />
                    <div className="title">
                        <p>เลือกแบรนด์</p>
                    </div>
                    <Nav />
                </div>
                <div className="downloadbrand-brand container">
                    {this.showBrands()}
                </div>
                <Footer />
            </div>
        )
    }
}
 
const mapStateToProps = ({ brand, document }) => {
    return { 
        brands: brand.brands,
        documents: document.documents,
    }
}
 
export default connect(mapStateToProps, { 
    brandFetch, documentFetchBrand
})(Downloadbrand)